import {useDispatch, useSelector} from 'react-redux';

import {fetchMe, isAuthenticatedSelector, userSelector} from 'entities/user';

import {store} from '../../../index';
import {getAccessToken, getRefreshToken} from '../../../shared/api/auth';
import {useYandexMetrika} from '../../../shared/lib/hooks/useYandexMetrika';
import {usePeriodicFetch} from '../../../shared/lib/hooks/usePeriodicFetch';

type AppDispatch = typeof store.dispatch;


export const UserFetchMe = () => {
    const dispatch = useDispatch<AppDispatch>();
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const userData = useSelector(userSelector);
    const isDeletionPage = window.location.pathname.includes('/confirm-deletion/');
    const isPublicStatusPage = window.location.pathname.startsWith('/status/');
    const isPublicUserReportPage = window.location.pathname.startsWith('/report/');

    const hasSession = isAuthenticated || !!getAccessToken() || !!getRefreshToken();
    const shouldFetch = !isDeletionPage && !isPublicStatusPage && !isPublicUserReportPage && hasSession;
    const fetchPeriod = 120;

    const fetch = () => {
        shouldFetch && dispatch(fetchMe(!!userData));
    };

    useYandexMetrika(userData);

    usePeriodicFetch(shouldFetch, fetch, fetchPeriod);

    return null;
};